import { PopupModal } from "components/modals/ModalBox";
import React from "react";
import useButtonLoader from "hooks/useButtonLoader";
import { changeStatusUserAPI } from "services/user";
import { toastMessage } from "utils/toastMessage";
import { updateReportApi } from "services/report";

const ChangeSelectedUserStatus = ({
  selectedUserDetail,
  onClose,
  setUserList,
  userStatusModal,
  refetchUserList
}) => {
  const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");

  // change delete handler
  const changeStatusHandler = async () => {
    try {
      setButtonLoader(true);
      const reqData = {
        _id: selectedUserDetail?._id || "",
        type: "COMMENT",
        status: selectedUserDetail?._comment?.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
      };
      const { data: responseData, status } = await updateReportApi(reqData);
      if (status === 200) {
        refetchUserList()
        onClose();
        toastMessage(responseData.message, "success", "changeUserStatus");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoader(false);
    }
  };

  return (
    <>
      <PopupModal
        show={userStatusModal}
        handleClose={onClose}
        content={`If you delete this message then this will appear deleted in the chat inbox`}
        title={`Are you sure you want to ${selectedUserDetail?._comment.status === "ACTIVE" ? "delete" : "recover"} this comment?`}
        buttonLoader={buttonLoader}
        action={changeStatusHandler}
      />
    </>
  );
};

export default ChangeSelectedUserStatus;
